<script>
export default {
  props: {
    titleFontFace: {
      type: String,
      default: 'inherit'
    },
    contentFontFace: {
      type: String,
      default: 'inherit'
    },
    sections: {
      type: Array,
      default: []
    }
  },
  computed: {
    titleStyle() {
      return {
        'font-family': this.titleFontFace
      }
    },
    contentStyle() {
      return {
        'font-family': this.contentFontFace
      }
    }
  }
}
</script>
<template>
  <div class="accordion-wrapper">
    <f7-list class="accordion-list">
        <f7-list-item v-for="(section,index) in sections" accordion-item :title="section.title" class="title" :key="index">
          <f7-accordion-content>
              <f7-block>
                <div v-html="section.content" class="ql-editor"></div>
              </f7-block>
          </f7-accordion-content>
        </f7-list-item>
    </f7-list>
  </div>
</template>
<style scoped>
  .ql-editor {
    padding: 15px 1px;
  }
  /* .accordion-wrapper{
    padding: 10px 0px!important;
  } */
  .list {
    margin: 0px!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Accordion.vue